import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 19,
	viewBox: "0 0 21 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M20.5714 9.33331C20.5714 14.303 16.5403 18.3333 11.5714 18.3333C8.63743 18.3333 6.03857 16.9225 4.39629 14.7487L5.42486 13.2273C6.71828 15.2622 8.98714 16.619 11.5714 16.619C15.5889 16.619 18.8571 13.3507 18.8571 9.33331C18.8571 5.31588 15.5889 2.0476 11.5714 2.0476C7.99457 2.0476 5.02629 4.64303 4.41686 8.0476H6.85714L3.42857 13.1193L0 8.0476H2.67686C3.30086 3.68817 7.03886 0.333313 11.5714 0.333313C16.5403 0.333313 20.5714 4.3636 20.5714 9.33331ZM14.5714 10.643C14.5714 12.0496 13.4203 13.1905 12 13.1905C10.5797 13.1905 9.42857 12.0505 9.42857 10.643C9.42857 9.23646 10.4349 7.7896 12 5.47703C13.5651 7.7896 14.5714 9.23646 14.5714 10.643ZM11.0357 8.88674C11.0357 9.65131 12.3214 9.4456 12.3214 8.18988C12.3214 7.76131 12.1423 7.35588 11.9914 7.12274C11.6751 7.58646 11.0357 8.36131 11.0357 8.88674Z",
		fill: "#737373"
	})]
});
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
